// extracted by mini-css-extract-plugin
module.exports = {"spaceBlock":"space-module--space-block--4QxSe"};